/**
 * @fileoverview gRPC-Web generated client stub for authpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var proto_usrpb_useraccess_pb = require('../../proto/usrpb/useraccess_pb.js')
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.authpb = require('./auth_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.authpb.AuthServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.authpb.AuthServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authpb.LoginRequest,
 *   !proto.authpb.LoginResponse>}
 */
const methodDescriptor_AuthService_Login = new grpc.web.MethodDescriptor(
  '/authpb.AuthService/Login',
  grpc.web.MethodType.UNARY,
  proto.authpb.LoginRequest,
  proto.authpb.LoginResponse,
  /**
   * @param {!proto.authpb.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.LoginResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.authpb.LoginRequest,
 *   !proto.authpb.LoginResponse>}
 */
const methodInfo_AuthService_Login = new grpc.web.AbstractClientBase.MethodInfo(
  proto.authpb.LoginResponse,
  /**
   * @param {!proto.authpb.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.LoginResponse.deserializeBinary
);


/**
 * @param {!proto.authpb.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.authpb.LoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authpb.LoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authpb.AuthServiceClient.prototype.login =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authpb.AuthService/Login',
      request,
      metadata || {},
      methodDescriptor_AuthService_Login,
      callback);
};


/**
 * @param {!proto.authpb.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authpb.LoginResponse>}
 *     Promise that resolves to the response
 */
proto.authpb.AuthServicePromiseClient.prototype.login =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authpb.AuthService/Login',
      request,
      metadata || {},
      methodDescriptor_AuthService_Login);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authpb.LoginWebRequest,
 *   !proto.authpb.LoginWebResponse>}
 */
const methodDescriptor_AuthService_LoginWeb = new grpc.web.MethodDescriptor(
  '/authpb.AuthService/LoginWeb',
  grpc.web.MethodType.UNARY,
  proto.authpb.LoginWebRequest,
  proto.authpb.LoginWebResponse,
  /**
   * @param {!proto.authpb.LoginWebRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.LoginWebResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.authpb.LoginWebRequest,
 *   !proto.authpb.LoginWebResponse>}
 */
const methodInfo_AuthService_LoginWeb = new grpc.web.AbstractClientBase.MethodInfo(
  proto.authpb.LoginWebResponse,
  /**
   * @param {!proto.authpb.LoginWebRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.LoginWebResponse.deserializeBinary
);


/**
 * @param {!proto.authpb.LoginWebRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.authpb.LoginWebResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authpb.LoginWebResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authpb.AuthServiceClient.prototype.loginWeb =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authpb.AuthService/LoginWeb',
      request,
      metadata || {},
      methodDescriptor_AuthService_LoginWeb,
      callback);
};


/**
 * @param {!proto.authpb.LoginWebRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authpb.LoginWebResponse>}
 *     Promise that resolves to the response
 */
proto.authpb.AuthServicePromiseClient.prototype.loginWeb =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authpb.AuthService/LoginWeb',
      request,
      metadata || {},
      methodDescriptor_AuthService_LoginWeb);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authpb.LoginUserRequest,
 *   !proto.authpb.LoginResponse>}
 */
const methodDescriptor_AuthService_Loginuser = new grpc.web.MethodDescriptor(
  '/authpb.AuthService/Loginuser',
  grpc.web.MethodType.UNARY,
  proto.authpb.LoginUserRequest,
  proto.authpb.LoginResponse,
  /**
   * @param {!proto.authpb.LoginUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.LoginResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.authpb.LoginUserRequest,
 *   !proto.authpb.LoginResponse>}
 */
const methodInfo_AuthService_Loginuser = new grpc.web.AbstractClientBase.MethodInfo(
  proto.authpb.LoginResponse,
  /**
   * @param {!proto.authpb.LoginUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.LoginResponse.deserializeBinary
);


/**
 * @param {!proto.authpb.LoginUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.authpb.LoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authpb.LoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authpb.AuthServiceClient.prototype.loginuser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authpb.AuthService/Loginuser',
      request,
      metadata || {},
      methodDescriptor_AuthService_Loginuser,
      callback);
};


/**
 * @param {!proto.authpb.LoginUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authpb.LoginResponse>}
 *     Promise that resolves to the response
 */
proto.authpb.AuthServicePromiseClient.prototype.loginuser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authpb.AuthService/Loginuser',
      request,
      metadata || {},
      methodDescriptor_AuthService_Loginuser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authpb.RefreshTokenRequest,
 *   !proto.authpb.LoginResponse>}
 */
const methodDescriptor_AuthService_RefreshToken = new grpc.web.MethodDescriptor(
  '/authpb.AuthService/RefreshToken',
  grpc.web.MethodType.UNARY,
  proto.authpb.RefreshTokenRequest,
  proto.authpb.LoginResponse,
  /**
   * @param {!proto.authpb.RefreshTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.LoginResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.authpb.RefreshTokenRequest,
 *   !proto.authpb.LoginResponse>}
 */
const methodInfo_AuthService_RefreshToken = new grpc.web.AbstractClientBase.MethodInfo(
  proto.authpb.LoginResponse,
  /**
   * @param {!proto.authpb.RefreshTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.LoginResponse.deserializeBinary
);


/**
 * @param {!proto.authpb.RefreshTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.authpb.LoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authpb.LoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authpb.AuthServiceClient.prototype.refreshToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authpb.AuthService/RefreshToken',
      request,
      metadata || {},
      methodDescriptor_AuthService_RefreshToken,
      callback);
};


/**
 * @param {!proto.authpb.RefreshTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authpb.LoginResponse>}
 *     Promise that resolves to the response
 */
proto.authpb.AuthServicePromiseClient.prototype.refreshToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authpb.AuthService/RefreshToken',
      request,
      metadata || {},
      methodDescriptor_AuthService_RefreshToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authpb.ValidateCodeRequest,
 *   !proto.authpb.ValidateCodeResponse>}
 */
const methodDescriptor_AuthService_ValidateCode = new grpc.web.MethodDescriptor(
  '/authpb.AuthService/ValidateCode',
  grpc.web.MethodType.UNARY,
  proto.authpb.ValidateCodeRequest,
  proto.authpb.ValidateCodeResponse,
  /**
   * @param {!proto.authpb.ValidateCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.ValidateCodeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.authpb.ValidateCodeRequest,
 *   !proto.authpb.ValidateCodeResponse>}
 */
const methodInfo_AuthService_ValidateCode = new grpc.web.AbstractClientBase.MethodInfo(
  proto.authpb.ValidateCodeResponse,
  /**
   * @param {!proto.authpb.ValidateCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.ValidateCodeResponse.deserializeBinary
);


/**
 * @param {!proto.authpb.ValidateCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.authpb.ValidateCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authpb.ValidateCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authpb.AuthServiceClient.prototype.validateCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authpb.AuthService/ValidateCode',
      request,
      metadata || {},
      methodDescriptor_AuthService_ValidateCode,
      callback);
};


/**
 * @param {!proto.authpb.ValidateCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authpb.ValidateCodeResponse>}
 *     Promise that resolves to the response
 */
proto.authpb.AuthServicePromiseClient.prototype.validateCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authpb.AuthService/ValidateCode',
      request,
      metadata || {},
      methodDescriptor_AuthService_ValidateCode);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authpb.RefreshAccessRequest,
 *   !proto.authpb.RefreshAccessResponse>}
 */
const methodDescriptor_AuthService_RefreshAccess = new grpc.web.MethodDescriptor(
  '/authpb.AuthService/RefreshAccess',
  grpc.web.MethodType.UNARY,
  proto.authpb.RefreshAccessRequest,
  proto.authpb.RefreshAccessResponse,
  /**
   * @param {!proto.authpb.RefreshAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.RefreshAccessResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.authpb.RefreshAccessRequest,
 *   !proto.authpb.RefreshAccessResponse>}
 */
const methodInfo_AuthService_RefreshAccess = new grpc.web.AbstractClientBase.MethodInfo(
  proto.authpb.RefreshAccessResponse,
  /**
   * @param {!proto.authpb.RefreshAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.RefreshAccessResponse.deserializeBinary
);


/**
 * @param {!proto.authpb.RefreshAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.authpb.RefreshAccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authpb.RefreshAccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authpb.AuthServiceClient.prototype.refreshAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authpb.AuthService/RefreshAccess',
      request,
      metadata || {},
      methodDescriptor_AuthService_RefreshAccess,
      callback);
};


/**
 * @param {!proto.authpb.RefreshAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authpb.RefreshAccessResponse>}
 *     Promise that resolves to the response
 */
proto.authpb.AuthServicePromiseClient.prototype.refreshAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authpb.AuthService/RefreshAccess',
      request,
      metadata || {},
      methodDescriptor_AuthService_RefreshAccess);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authpb.AccountEmailAuthRequest,
 *   !proto.authpb.AccountEmailAuthResponse>}
 */
const methodDescriptor_AuthService_AccountEmailAuth = new grpc.web.MethodDescriptor(
  '/authpb.AuthService/AccountEmailAuth',
  grpc.web.MethodType.UNARY,
  proto.authpb.AccountEmailAuthRequest,
  proto.authpb.AccountEmailAuthResponse,
  /**
   * @param {!proto.authpb.AccountEmailAuthRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.AccountEmailAuthResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.authpb.AccountEmailAuthRequest,
 *   !proto.authpb.AccountEmailAuthResponse>}
 */
const methodInfo_AuthService_AccountEmailAuth = new grpc.web.AbstractClientBase.MethodInfo(
  proto.authpb.AccountEmailAuthResponse,
  /**
   * @param {!proto.authpb.AccountEmailAuthRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.AccountEmailAuthResponse.deserializeBinary
);


/**
 * @param {!proto.authpb.AccountEmailAuthRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.authpb.AccountEmailAuthResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authpb.AccountEmailAuthResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authpb.AuthServiceClient.prototype.accountEmailAuth =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authpb.AuthService/AccountEmailAuth',
      request,
      metadata || {},
      methodDescriptor_AuthService_AccountEmailAuth,
      callback);
};


/**
 * @param {!proto.authpb.AccountEmailAuthRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authpb.AccountEmailAuthResponse>}
 *     Promise that resolves to the response
 */
proto.authpb.AuthServicePromiseClient.prototype.accountEmailAuth =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authpb.AuthService/AccountEmailAuth',
      request,
      metadata || {},
      methodDescriptor_AuthService_AccountEmailAuth);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.authpb.EmailAuthCodeRequest,
 *   !proto.authpb.EmailAuthCodeResponse>}
 */
const methodDescriptor_AuthService_EmailAuthCode = new grpc.web.MethodDescriptor(
  '/authpb.AuthService/EmailAuthCode',
  grpc.web.MethodType.UNARY,
  proto.authpb.EmailAuthCodeRequest,
  proto.authpb.EmailAuthCodeResponse,
  /**
   * @param {!proto.authpb.EmailAuthCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.EmailAuthCodeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.authpb.EmailAuthCodeRequest,
 *   !proto.authpb.EmailAuthCodeResponse>}
 */
const methodInfo_AuthService_EmailAuthCode = new grpc.web.AbstractClientBase.MethodInfo(
  proto.authpb.EmailAuthCodeResponse,
  /**
   * @param {!proto.authpb.EmailAuthCodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.authpb.EmailAuthCodeResponse.deserializeBinary
);


/**
 * @param {!proto.authpb.EmailAuthCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.authpb.EmailAuthCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.authpb.EmailAuthCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authpb.AuthServiceClient.prototype.emailAuthCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authpb.AuthService/EmailAuthCode',
      request,
      metadata || {},
      methodDescriptor_AuthService_EmailAuthCode,
      callback);
};


/**
 * @param {!proto.authpb.EmailAuthCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.authpb.EmailAuthCodeResponse>}
 *     Promise that resolves to the response
 */
proto.authpb.AuthServicePromiseClient.prototype.emailAuthCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authpb.AuthService/EmailAuthCode',
      request,
      metadata || {},
      methodDescriptor_AuthService_EmailAuthCode);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AuthService_Logout = new grpc.web.MethodDescriptor(
  '/authpb.AuthService/Logout',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.google.protobuf.Empty,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_AuthService_Logout = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.authpb.AuthServiceClient.prototype.logout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/authpb.AuthService/Logout',
      request,
      metadata || {},
      methodDescriptor_AuthService_Logout,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.authpb.AuthServicePromiseClient.prototype.logout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/authpb.AuthService/Logout',
      request,
      metadata || {},
      methodDescriptor_AuthService_Logout);
};


module.exports = proto.authpb;

